export default __webpack_public_path__ + "static/media/login-background.7854f246.svg";